import { createSelector } from 'reselect';
import { OrderStatusEnum } from '../../../../generated';
import { sortedOrderSelector } from './sortedOrderSelector';

export const pastOrdersSelector = createSelector(sortedOrderSelector, (orders) =>
  orders.filter((x) => x.orderStatusEnum === OrderStatusEnum.Completed),
);
